var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/lib/Avatar.tsx
import { default as MuiAvatar } from "@mui/material/Avatar";
import React, { useEffect } from "react";
import { avSettingsApi } from "@availity/api-axios";
import { UserIcon } from "@availity/mui-icon";
import { jsx } from "react/jsx-runtime";
var sizeStyling = {
  xs: { width: 18, height: 18, fontSize: "caption.fontSize" },
  s: { width: 24, height: 24, fontSize: "caption.fontSize" },
  m: { width: 40, height: 40, fontSize: "h5.fontSize", fontWeight: "fontWeightBold" },
  l: { width: 80, height: 80, fontSize: "h3.fontSize", fontWeight: "fontWeightBold" },
  xl: { width: 140, height: 140, fontSize: "h1.fontSize", fontWeight: "fontWeightBold" }
};
var getInitials = (name, size) => {
  if (name.split(" ").length > 1 && size !== "xs") {
    return `${name.split(" ")[0][0]}${name.split(" ")[1][0]}`;
  }
  return name.charAt(0);
};
var formatChildren = (children, size) => {
  if (typeof children === "string") {
    return getInitials(children, size).toUpperCase();
  }
  return children;
};
var Avatar = (_a) => {
  var _b = _a, { children, size = "xl", src, sx } = _b, rest = __objRest(_b, ["children", "size", "src", "sx"]);
  const [avatar, setAvatar] = React.useState();
  useEffect(() => {
    const fetchAvatar = () => __async(void 0, null, function* () {
      if (src) {
        setAvatar(src);
      } else {
        const resp = yield avSettingsApi.getApplication("AVATAR");
        const avi = resp.data.settings[0].avatar;
        setAvatar(avi);
      }
    });
    fetchAvatar();
  }, [src]);
  return /* @__PURE__ */ jsx(
    MuiAvatar,
    __spreadProps(__spreadValues({}, rest), {
      variant: "circular",
      src: children ? void 0 : avatar,
      sx: __spreadValues(__spreadValues({}, sx), sizeStyling[size] || sizeStyling.xl),
      children: children ? formatChildren(children, size) : /* @__PURE__ */ jsx(UserIcon, {})
    })
  );
};
export {
  Avatar
};
